import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/pflugerville")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Awnings, Covers & Shade in Pflugerville, TX | Texas Made Shade",
      description: "Custom welded awnings, sail shades, patio & pergola covers, marine canvas and aluminum fabrication for Pflugerville & Travis County.",
      image: hero,
      socialTitle: "Custom Awnings & Shade — Pflugerville, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving Pflugerville and Travis County.",
      keywords: "awnings Pflugerville, awning company Pflugerville, custom awnings Pflugerville, sail shades Pflugerville, patio covers Pflugerville, pergola covers Pflugerville, metal awnings Pflugerville, canvas awnings Pflugerville, Texas Made Shade",
    }),
    scripts: cityHeadScripts("Pflugerville", "Travis County"),
  }),
  component: () => <CityHomePage city="Pflugerville" region="Travis County" />,
});
